export class WebhookV1IssueMutedNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "controlName",
            "baseName": "controlName",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "muted",
            "baseName": "muted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1IssueMutedNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
